import * as React from "react";
import { PropsWithChildren } from "react";
import { useLoaderData } from "react-router";
import { Entrypoint, EntrypointContext } from "./EntrypointContext";

export const EntrypointProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const entrypoint = useLoaderData<Entrypoint>();

  return (
    <EntrypointContext.Provider value={entrypoint}>
      {children}
    </EntrypointContext.Provider>
  );
};
